import { render, staticRenderFns } from "./modalProformaInvoiceDetail.vue?vue&type=template&id=91b87f14&scoped=true"
import script from "./modalProformaInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./modalProformaInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./modalProformaInvoiceDetail.vue?vue&type=style&index=0&id=91b87f14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b87f14",
  null
  
)

export default component.exports